// components/PaginationControls.js
import { usePagination } from "../contexts/PaginationContext";
import 'bootstrap-icons/font/bootstrap-icons.css';

const PaginationControls = ({ currentCount }) => {
  const { page, setPage, totalPages, totalElements } = usePagination();

  return (
    <div className="d-flex flex-column align-items-center mt-3">
      <div className="pagination d-flex justify-content-center">
        <button 
          className="btn btn-icon-only btn-rounded btn-outline-secondary mb-0 me-2"
          onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          disabled={page === 0}
          title="Página anterior"
        >
          <i className="bi bi-chevron-left"></i>
        </button>
        <span className="text-xs text-secondary mx-2">
          Página {page + 1} de {totalPages || 1}
        </span>
        <button 
          className="btn btn-icon-only btn-rounded btn-outline-secondary mb-0 ms-2"
          onClick={() => setPage((prev) => prev + 1)}
          disabled={page + 1 >= totalPages}
          title="Próxima página"
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
      <div className="text-xxs text-secondary mt-2 opacity-8">
        Mostrando {currentCount} de {totalElements} registros
      </div>
    </div>
  );
};

export default PaginationControls;
